module.exports = __webpack_public_path__ + "static/img/declaration-others-card-active.f6c92c07.svg";